module.exports = __webpack_public_path__ + "static/img/banner_background_01.d30c8e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/pc/images/banner_background_01.png
// module id = MC17
// module chunks = 0